module.exports = __webpack_public_path__ + "img/noAvatar.f35d7913.png";